import ChatMessageCard from "../ChatMessageCard/ChatMessageCard.vue";

export default {
    name: "ChatMessageCards",
    components: {
        ChatMessageCard
    },
    props: {
        cards: {
            type: Array,
            required: true
        }
    }
}